module.exports = __webpack_public_path__ + "img/sign-in-img.82a1902f.jpg";